import type { State } from './typings'

export const initialState: State = {
  transition: true,
}
